export default __webpack_public_path__ + "static/media/Strangler's Mask of the Hidden Tomb.9dd48bad.jpg";